import {showNotification} from 'platform/components';

import {ApiError} from 'shared/web';

import {getApiErrorMessages} from './getApiErrorMessages';
import {getApiValidationErrors} from './getApiValidationErrors';

type ValidationErrors = ReturnType<typeof getApiValidationErrors>;

type OptionsCallback = {
  error: ApiError;
  validationErrors: ValidationErrors;
};

export type ApiErrorOptions = {
  silent?: boolean;
  silentOnValidationError?: boolean;
  callback?: (args: OptionsCallback) => void;
  setErrors?: (errors: ValidationErrors) => void;
};

/**
 * @about Handle API errors by showing toast notifications with error messages.
 */
export function handleApiError(error: ApiError, options?: ApiErrorOptions) {
  const validationErrors = getApiValidationErrors(error);

  options?.callback?.({error, validationErrors});

  options?.setErrors?.(validationErrors);

  if (options?.silent || (options?.silentOnValidationError && !!validationErrors)) {
    return;
  }

  showNotification.error(getApiErrorMessages(error));
}
